<div class="p-3 h-100 w-100">
  <div class="grid pt-0">
    <q-customgrid [activeButton]="activeButton" [customgridName]="'ListeModulesApprenantEL'" [idDonnee]="idDonnee" [idRelation]="idDonnee2"></q-customgrid>
  </div>
</div>
